import { AdminWorkActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { AdminWorkFormData } from 'src/screens/General/screens/AdminWork/components/AdminWorkForm';
import { Dispatch } from 'redux';
import { SagaPromise } from './auth-actions';

export interface GetAdminWorksAction {
    type: typeof AdminWorkActions.FETCH_ADMIN_WORKS;
    payload: QueryParams;
    all?: any;
}

export function getAdminWorks(params: QueryParams): GetAdminWorksAction {
    return {
        type: AdminWorkActions.FETCH_ADMIN_WORKS,
        payload: params,
    };
}
interface QueryParamsAll extends QueryParams {
    all?: any;
}
export function getAdminWorksCsv(params: QueryParamsAll): GetAdminWorksAction {
    return {
        type: AdminWorkActions.FETCH_ADMIN_WORKS_CSV,
        payload: params,
        all: params.all,
    };
}
export interface GetAdminWorkAction {
    type: typeof AdminWorkActions.FETCH_ADMIN_WORK;
    payload: {
        id: string | number;
    };
}

export function getAdminWork(id: string | number): GetAdminWorkAction {
    return {
        type: AdminWorkActions.FETCH_ADMIN_WORK,
        payload: { id },
    };
}

export interface DeleteAdminWorkAction {
    type: typeof AdminWorkActions.DELETE_ADMIN_WORK;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteAdminWork(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteAdminWorkAction {
    return {
        type: AdminWorkActions.DELETE_ADMIN_WORK,
        payload: { id, onSuccess, onError },
    };
}

export interface PersistAdminWorkAction {
    type: typeof AdminWorkActions.PERSIST_ADMIN_WORK;
    payload: {
        data: AdminWorkFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistAdminWork(data: AdminWorkFormData, callbacks: SagaPromise<any>): PersistAdminWorkAction {
    return {
        type: AdminWorkActions.PERSIST_ADMIN_WORK,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistAdminWork = (data: AdminWorkFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistAdminWork(data, { resolve, reject }));
    });
};

export type Actions = GetAdminWorksAction | GetAdminWorkAction | DeleteAdminWorkAction | PersistAdminWorkAction;
